export const MODELS = {
    Company: 1,
    Invitation: 2,
    Event: 3,
    Announcement: 4,
    Profile: 5,
    Contractor: 6,
    Supplier: 7,
    Log: 8,
    Employee: 9,
    EmployeeCompanyDocument: 10,
    SupplierCompanyDocument: 11,
    SupplierVehicleCompanyDocument: 12,
    WorkShift: 13,
    Privilege: 14,
    Zone: 16,
    Devices: 17,
    Reports: 18,
    BackUp: 19,
    HomeOffice: 20,
    Onboarding: 21,
    Hospitality: 22,
    EmailSettings: 23,
    User: 25,
    vehicle: 26,
    UserAccessLog: 27,
    VehicleAccessLog: 28,
    DocumentsForContractor: 29,
    DocumentsForContractorVehicles: 30,
    Department: 31,
    Contract: 32,
    Order: 33,
    Holliday: 34,
    Attendance: 35,
    Card: 36,
    CardDesigner: 37,
    Resource: 38,
    ContractorEmployee: 39,
    ContractorVehicle: 40,
    SupplierEmployee: 41,
    SupplierVehicle: 42,
    LogInLog: 43,
    LogAction: 44,
    Guard: 45,
    HID: 46,
    HIDInput: 47,
    HIDOutput: 48,
    HIDSio: 49,
    HIDReader: 50,
    SYSTEM_CONFIG:54,
    HARD_DELETE:52,
    CHART:51,
    FOODIE:53,
    APPROVAL_FLOW:55,
    VISITOR_TYPE:56,
    INGREDIENT:57,
    FOODIE_ITEM:58,
    FOODIE_MENU:59,
    FOODIE_CAFETERIA:60,
    FOODIE_SHIFT:61,
    SERVICE_TYPE:62,
    DISTRIBUTION_CENTER:63,
    LOGISTIC_REQUEST:64,
    FOODIE_USER_MENU_SELECTION:65,
    FOODIE_EXTRA_REQUEST:66,
    FOODIE_MEAL_TIME:67,
    FOODIE_DEPARTMENT_POLICIES: 68,
    VISITOR_INVITATION: 69,
    VISITOR_REQUEST:70,
    VISITOR:71,
    KITCHEN_TICKETS:72,
    KITCHEN_TICKETS_HISTORY:73,
    FOODIE_REQUEST: 74,
    REQUEST_ACCESS:75,
    VISITOR_INCOMING_INVITATION:76,
    TOTAL_MEALS: 77,
    FOODIE_MEAL_FORECAST: 78,
    FOODIE_ACCESS: 79,
    FINE_TYPE:80,
    TRAFFIC_DASHBOARD_GEOFENCES:81,
    TRAFFIC_DASHBOARD_FINES:82,
    TRAFFIC_USERS:83,
    TRAFFIC_MANAGE_FINES:84,
    TRAFFIC_MANAGE_GEOFENCES:85,
    EVENT_STATUS:86,
    CONTRACTOR_APPROVAL_FLOW:87,
    EVENT_MANAGE: 88,
    CONTRACTOR_MANAGE: 89,
    SUPPLIER_APPROVAL_FLOW:90,
    SUPPLIER_MANAGE: 91,
    FINE: 92,//Mobile module
    EQUIPMENT_MATERIAL: 93,
    EQUIPMENT_ACCESS_LOG: 94,
    ATTENDANCE_SHIFT: 97,
    ATTENDANCE_SETTING: 98,
    ATTENDANCE_DEPARTMENT_POLICIES: 99,
    KITCHEN_ACCESS:100,
    KITCHEN_ACCESS_HISTORY:101,
    FOODIE_SETTING:102,
    PILGRIMS_MEAL_TIME_REPORT: 110,
    PILGRIMS_ACCESS_REPORT: 111
};

export const getModelKeyById = (id) => {
    const key = Object.keys(MODELS).find(key => MODELS[key] === id);
return key || null;
};

export const MODELS_NAME = {
    zone: "zone",
    contract:"contract",
    contractor:"contractor",
    supplier:"supplier",
    employee:"employee",
    vehicle:"vehicle",
    user:"user",
    contractorEmployee:"contractorEmployee",
    contractorVehicle:"contractorVehicle",
    supplierEmployee:"supplierEmployee",
    supplierVehicle:"supplierVehicle",
    employeeVehicle:"employeeVehicle",
    case3:"case3",
    report: "report"
};
